import React from "react";
import { formatAppDate } from "../../helpers/date-formatter";
import { Link } from "react-router-dom";

function UserBillingInvoiceSummaryTable({ data }) {
  return (
    <>
      <table className="w-full min-w-[640px] table-auto">
        <thead>
          <tr>
            {["txn id", "amount (€)", "transaction date", "coupon"].map(
              (el, id) => (
                <th
                  key={el}
                  className={`border-y bg-neutral-light border-neutral-light py-3 px-5 ${
                    id == 0 ? "text-left" : "text-center"
                  }`}
                >
                  <span className="text-[11px] font-bold uppercase text-slate-400">
                    {el}
                  </span>
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((dataItem) => {
            const {
              id,
              transactionId,
              currency,
              totalAmount,
              couponCode,
              transactionDate,
            } = dataItem;

            return (
              <tr key={id}>
                <td className="py-3 px-5 border-b  w-[100px]">
                  <div className="flex flex-col gap-2">
                    <span className="text-left text-xs font-semibold  underline hover:text-icon-blue">
                      <Link to={`/invoice/${id}`}>{transactionId}</Link>
                    </span>
                  </div>
                </td>
                <td className="text-center py-3 px-5 border-b  w-32">
                  <span className="text-xs font-semibold ">
                    {currency}
                    {totalAmount}
                  </span>
                </td>
                <td className="text-center py-3 px-5 border-b  w-32">
                  <span className="text-xs font-semibold ">
                    {formatAppDate(transactionDate)}
                  </span>
                </td>
                <td className="text-center py-3 px-5 border-b  w-32">
                  <span className="text-xs font-semibold ">
                    {couponCode === null ? "-" : couponCode}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

export default UserBillingInvoiceSummaryTable;
